module.exports = __webpack_public_path__ + "static/media/pc_mouse.d7bdaa6c.png";